import { formatBrDate } from "../../utils/formats";
import { Box, Typography } from "@mui/material";

const TableComponent = ({ data }) => {
    return (
        <>
        <table border="1" style={{ width: '100%', borderCollapse: 'collapse', marginTop: '15px' }}>
            <thead>
                <tr style={{fontSize: '0.9rem'}}>
                    <th>Kit</th>
                    <th>Data</th>
                    <th>Tamanho</th>
                    <th>Status</th>
                </tr>
            </thead>
            <tbody>
                {data.map((item, index) => (
                    <tr key={index} style={{fontSize: '0.8rem'}}>
                        <td>{item.kit_number}</td>
                        <td>{formatBrDate(item.returned_at)}</td>
                        <td>{item.tamanho || 'N/A'}</td>
                        <td style={{color: item.prod_situation ? 'green' : 'red', fontWeight: 'bold'}}>{item.prod_situation ? 'Vendido' : 'Devolvido'}</td>
                    </tr>
                ))}
            </tbody>
        </table>
                <Box>
                    <Typography variant="h5" fontWeight={"bold"}>
                        Deseja inserir mesmo assim ?
                    </Typography>
                </Box>
        </>
    );
};


export default TableComponent